<template>
  <div ref="nodeRef" :style="{ width: nodeData.nodeWidth + 'px' }" class="comp-custom-node node-isbold" :class="[nodeData.isCurrent && 'is-border']">
    <handle class="handle-style" :isConnectable="false" :class="{ 'input-output-display-dot': props.customData.data.nodeAttr === 'start', 'node-handle-active': nodeData.isCurrent }" type="target" :position="Position.Left" />
    <div class="node-div">
      <div class="icon-circle" :style="{ backgroundColor: getBackgroundColor(nodeData) }"></div>
      <div>{{ nodeData.label }}</div>
    </div>
    <handle class="handle-style" :class="{ 'input-output-display-dot': props.customData.data.nodeAttr === 'end', 'node-handle-active': nodeData.isCurrent }" type="source" :position="Position.Right" />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { Position, Handle } from '@vue-flow/core';
import _ from 'lodash';
const props = defineProps(['customData']);
const emits = defineEmits(['cb']);
const nodeData = computed(() => _.cloneDeep(props.customData.data));
const nodeId = computed(() => _.cloneDeep(props.customData.id));
const getBackgroundColor = (nodeData) => {
  if (nodeData.status == 5) return `rgb(var(--success-4))`;
  if (nodeData.status == 1) return `rgb(var(--orange-4))`;
  if (nodeData.status == 0) return `var(--color-border-4)`;
};
const nodeRef = ref(null);
onMounted(() => {
  emits('cb', { nodeId: nodeId.value, nodeWidth: nodeRef.value?.clientWidth, nodeLabel: nodeData.value?.label });
});
</script>
<style scoped lang="less">
@import './custom-node.less';
</style>
